import {useQuery} from 'react-query'
import {BookingExtraEditModalForm} from './BookingExtraEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_dashboard/helpers'
import {useListView} from '../core/ListViewProvider'
import { getOneById } from '../../../../services/common_requests'
import { initialBookingExtra } from '../core/_models'

const BookingExtraEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: BookingExtra,
    error,
  } = useQuery(
    `${QUERIES.BOOKING_EXTRAS_LIST}-BookingExtra-${itemIdForUpdate}`,
    () => {
      return getOneById(itemIdForUpdate,"/booking-extras")
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <BookingExtraEditModalForm isBookingExtraLoading={isLoading} BookingExtra={{...initialBookingExtra, _id: undefined}} />
  }

  if (!isLoading && !error && BookingExtra) {
    return <BookingExtraEditModalForm isBookingExtraLoading={isLoading} BookingExtra={BookingExtra} />
  }

  return null
}

export {BookingExtraEditModalFormWrapper}
